import { createFileRoute, notFound } from '@tanstack/react-router'

import { FEATURE_USER_NOTES } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import DashboardNotes from '@/dashboard/components/DashboardNotes/DashboardNotes'

export const Route = createFileRoute('/_learning/_my-learning/home/notes')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-notes',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_USER_NOTES)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <DashboardNotes />
}
